module.exports = __webpack_public_path__ + "static/media/oneMoreCriteria.30f74fe0.png";